import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

import { ABOUT_BANNER_SIZE } from '@modules/professional/config/constants';

export const InfoContainer: StyleRule = () => ({
    gridTemplateColumns: `${pxToRem(ABOUT_BANNER_SIZE)} 1fr`,
    gridGap: pxToRem(43),
});

export const TeamMemberContent: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(24),
    fontSize: pxToRem(20),
    display: 'inline',
    '& > * .ui-box': {
        display: 'inline',
    },
    [theme.screen.tablet]: {
        marginTop: 0,
        marginLeft: pxToRem(24),
    },
});

const TEXT_BOTTOM_MARGIN_SIZE = pxToRem(8);

export const TeamMemberName: StyleRule = ({ theme }) => ({
    marginBottom: TEXT_BOTTOM_MARGIN_SIZE,
    color: theme.siteVariables.colors.charcoal['350'],
});

export const TeamMemberRole: StyleRule = ({ theme }) => ({
    marginBottom: TEXT_BOTTOM_MARGIN_SIZE,
    color: theme.siteVariables.colors.charcoal['100'],
});

export const TeamMemberPhone: StyleRule = () => ({
    overflow: 'hidden',
    width: '11ch',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingTop: pxToRem(1),
    display: 'inline',
});

export const TeamMemberClassTest: StyleRule = () => ({
    display: 'inline',
    '& > div': {
        '& > *': {
            display: 'inline-block',
        },
    },
});

export const TeamMemberLinks: StyleRule = () => ({
    marginTop: pxToRem(12),
});

export const TeamMeberContactLink: StyleRule = ({ theme }) => ({
    display: 'inline',
    fontSize: pxToRem(18),
    marginRight: pxToRem(24.5),
    color: theme.siteVariables.colors.charcoal[250],
});

export const TeamMemberAboutSection: StyleRule = () => ({
    marginTop: pxToRem(46),
});

export const TeamMemberGrid: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: `1fr`,
    marginTop: pxToRem(20),
    wordBreak: 'break-word',
    [theme.screen.tablet]: {
        gridTemplateColumns: `${pxToRem(172.5)} auto`,
    },
});

export const IconClass: StyleRule = () => ({
    height: pxToRem(19),
    width: pxToRem(18),
    marginRight: pxToRem(4),
    top: pxToRem(-2),
    position: 'relative',
});

export const AboutSectionHeader: StyleRule = () => ({
    marginBottom: pxToRem(16),
});

export const TeamMemberAboutContent: StyleRule = ({ theme }) => ({
    '& p': {
        marginBottom: pxToRem(26),
        marginTop: '0',
        lineHeight: '130%',
    },
    '& > * a': {
        color: 'inherit',
        textDecoration: `underline`,

        '&:hover': {
            color: `${theme.siteVariables.colors.charcoal['000']}`,
        },
    },
});

export const PhoneNumberSpan: StyleRule = () => ({
    textOverflow: 'ellipsis',
    maxWidth: '6ch',
    overflow: 'hidden',
});
